import type { AdditionalCoordinate } from "types/api_types";
import type { MappingType, Vector3 } from "viewer/constants";

export type AdHocMeshInfo = {
  mappingName: string | null | undefined;
  mappingType: MappingType | null | undefined;
  useDataStore?: boolean | null | undefined;
  preferredQuality?: number | null | undefined;
  opacity?: number | undefined;
  isVisible?: boolean | undefined;
};
export type LoadAdHocMeshAction = ReturnType<typeof loadAdHocMeshAction>;
export type LoadPrecomputedMeshAction = ReturnType<typeof loadPrecomputedMeshAction>;

export type SegmentationAction = LoadAdHocMeshAction | LoadPrecomputedMeshAction;

export const loadAdHocMeshAction = (
  segmentId: bigint,
  seedPosition: Vector3,
  seedAdditionalCoordinates: AdditionalCoordinate[] | undefined | null,
  extraInfo?: AdHocMeshInfo,
  layerName?: string,
) =>
  ({
    type: "LOAD_AD_HOC_MESH_ACTION",
    segmentId,
    seedPosition,
    seedAdditionalCoordinates,
    extraInfo,
    layerName,
  }) as const;

export const loadPrecomputedMeshAction = (
  segmentId: bigint,
  seedPosition: Vector3,
  seedAdditionalCoordinates: AdditionalCoordinate[] | undefined | null,
  meshFileName: string,
  opacity: number | undefined,
  isVisible: boolean | undefined,
  layerName?: string | undefined,
) =>
  ({
    type: "LOAD_PRECOMPUTED_MESH_ACTION",
    segmentId,
    seedPosition,
    seedAdditionalCoordinates,
    meshFileName,
    opacity,
    isVisible,
    layerName,
  }) as const;
